import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[blurEvent]',
})
export class BlurOnComponentDirective {
  @Output() blurEvent = new EventEmitter<Event>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      // wait for changing focus on active element
      setTimeout(() => {
        const targetElement = document.activeElement as HTMLElement;
        if (targetElement && !this.elementRef.nativeElement.contains(targetElement)) {
          this.blurEvent.emit();
        }
      });
    }
  }
}
